import { Expose } from "class-transformer";
import { IsOptional, IsString, IsNumber } from "class-validator";

export class ContractorDataModel {
  @IsNumber()
  @Expose()
  id!: number;
  @IsString()
  @Expose()
  city!: string;
  @IsString()
  @Expose()
  country!: string;
  @IsString()
  @IsOptional()
  @Expose()
  email!: string;
  @IsOptional()
  @IsNumber()
  @Expose()
  importedContractorId!: number | null;
  @IsString()
  @Expose()
  name!: string;
  @IsString()
  @IsOptional()
  @Expose()
  phoneNumber!: string;
  @IsString()
  @Expose()
  postalCode!: string;
  @IsNumber()
  @Expose()
  relationType!: number;
  @IsNumber()
  @Expose()
  sex!: number;
  @IsOptional()
  @IsString()
  @Expose()
  shortName!: string | null;
  @IsString()
  @Expose()
  streetAndNumber!: string;
  @IsOptional()
  @IsString()
  @Expose()
  surname!: string | null;
  @IsString()
  @Expose()
  tin!: string;
}
